import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useDispatch } from 'react-redux';
import { setPopupAdds } from '../store/page/actions';

const useRedirectPopupAdds = () => {
  const route = useRouter();
  const dispatch = useDispatch();

  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
  const APP_STORE_URL = process.env.NEXT_PUBLIC_DIGIROOM_APP_STORE;
  const PLAY_STORE_URL = process.env.NEXT_PUBLIC_DIGIROOM_PLAY_STORE;

  useEffect(() => {
    const { isAdds } = route.query;
    const pathname = window.location.pathname;
    const isAppPage = pathname.includes('/app');

    // do nothing if not /app
    if (!isAppPage) return;

    if (isAppPage) {
      const currentPath = window.location.pathname.replace('/app', '');
      const searchParams = window.location.search;

      if (isAdds === 'true') {
        const isAndroid = /android/i.test(navigator.userAgent);
        const isIOS = /iphone|ipod|ipad/i.test(navigator.userAgent);

        if (!isAndroid && !isIOS) {
          // fallback redirect if not mobile view
          window.location.href = PUBLIC_URL + currentPath + searchParams;
          return;
        }

        // show pop up in mobile view
        dispatch(
          setPopupAdds({
            isShown: true,
            urlRedirect: isAndroid ? PLAY_STORE_URL : APP_STORE_URL,
          })
        );
      } else if (isAdds !== undefined) {
        // fallback redirect if isAdds exists, but is not 'true'
        window.location.href = PUBLIC_URL + currentPath + searchParams;
      }
    }
  }, [route]);
};

export default useRedirectPopupAdds;
